<template>
  <div class="news">
    <common-layout>
      <div slot="header">
        <h3>通知公告</h3>
      </div>
      <div slot="container">
        <div class="news-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addNews"
            style="background: #623AA2; border: none;"
          >
            新增
          </el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>

        <div class="news-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (currentPage - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="标题" align="center">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <span size="medium">{{ scope.row.title }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="发布时间" align="center">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <span size="medium">{{ scope.row.releaseTime }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.releaseFlag == 0"
                >
                  确认发布
                </el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 0)" v-else>
                  取消发布
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="per_page"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>

    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="newForm"
        ref="newForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">
              <el-input v-model="newForm.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="副标题" prop="subtitle">
              <el-input v-model="newForm.subtitle" clearable></el-input>
            </el-form-item>
            <el-form-item label="发布时间" prop="releaseTime">
              <el-date-picker
                v-model="newForm.releaseTime"
                :picker-options="pickerOptions"
                type="datetime"
                placeholder="选择日期"
                style="text-align: left;width:100%"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="是否发布" prop="releaseFlag" style="text-align:left">
              <el-switch
                v-model="newForm.releaseFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
            <el-form-item label="同步发布" prop="platform">
              <el-select
                multiple
                v-model="newForm.platform"
                placeholder="请选择同步发布平台"
                style="width: 100%"
                @change="platformChange"
              >
                <el-option label="全部" :value="1"></el-option>
                <el-option label="创新券应用平台" :value="2"></el-option>
                <el-option label="兰州科技大市场" :value="3"></el-option>
                <el-option label="创新成果转移转化平台" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item style="text-align:center">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :headers="headers"
                :show-file-list="false"
                :on-success="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                :http-request="HouImgFile"
              >
                <img v-if="image" :src="imgUrl + image" class="img_border" />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  :class="{ is_border: !image }"
                ></i>
                <span class="upload_btn" v-if="!image">上传图片</span>
                <span v-else class="upload_btn">更换图片</span>
              </el-upload>
              <span class="del_img" v-show="image">
                <i class="el-icon-error" @click="deleteImg"></i>
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="zhaopian1"></el-row>
        <!-- <editor :quill-data="newForm.content" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
        <editor v-model="newForm.content" :upload-url="uploadURL" :img-show-url="imgUrl"></editor>

        <el-form-item style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="submitForm('newForm')">提交</el-button>
          <el-button @click="closeForm('newForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import editor from "../../components/yhQuillEditor";
import editor from '../../../components/tinymce-editor/tinymce-editor';
import CommonLayout from '../../../components/common-layout.vue';
import { DisabledDateFn } from '../../../utils/tool';
export default {
  components: {
    editor,
    CommonLayout
  },
  data() {
    return {
      is_submit: true,
      total: 10,
      per_page: 10,
      currentPage: 1,
      image: '',
      dialogFormVisible: false,
      searchValue: null,
      Title: '',
      tableData: [],
      deleteRow: [],
      pickerOptions: {
        disabledDate: this.disabledDateFn
      },
      newForm: {
        title: '',
        subtitle: '',
        image: '',
        content: '',
        releaseTime: '',
        releaseFlag: 0,
        platform: []
      },
      restrNewForm: '',
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }
        ],
        releaseTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    headers() {
      return {};
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  created() {
    this.getData();
    this.resetFomr(true);
  },
  methods: {
    platformChange(val) {
      if (val.find(i => i === 1)) {
        this.newForm.platform = [1];
      }
    },
    // 重置表单
    resetFomr(flag = false) {
      if (flag) {
        this.restrNewForm = JSON.stringify(this.newForm);
      } else [(this.newForm = JSON.parse(this.restrNewForm))];
    },
    //禁用日期选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    //富文本
    getQuillData(val) {
      this.newForm.content = val;
    },
    // 获取列表
    getData() {
      const params = {
        keyword: this.searchValue,
        page: this.currentPage,
        pageSize: this.per_page
      };
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/innovation/notice/page`, params)
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.total = res.data.total;
            // this.currentPage = res.data.current_page;
            // this.per_page = res.data.per_page;
          }
        })
        .catch(err => {
          console.log('开始搜索咨询err::', err);
        });
    },
    //新增
    addNews() {
      this.dialogFormVisible = true;
      this.Title = '新建';
      this.newForm = {
        title: '',
        subtitle: '',
        image: '',
        content: '',
        releaseTime: '',
        releaseFlag: 0
      };
      this.image = '';
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = '编辑';
      this.resetFomr();
      this.http
        .get(`${urlConfig.devUrl}apij2/admin-api/innovation/notice/get?id=${row.id}`)
        .then(res => {
          if (res.code == 0) {
            this.ResetSearch(['searchValue']);
            this.newForm = {
              id: res.data.id,
              title: res.data.title,
              subtitle: res.data.subtitle,
              image: res.data.image,
              content: res.data.content,
              releaseTime: res.data.releaseTime,
              releaseFlag: res.data.releaseFlag
            };
            this.image = res.data.image;
          }
        });
    },
    //删除
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http
            .request(
              `${urlConfig.devUrl}apij2/admin-api/innovation/notice/delete?ids=${[row.id]}`,
              '',
              'delete'
            )
            .then(res => {
              if (res.code == 0) {
                this.current_page = 1;

                this.ResetSearch(['searchValue']);

                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) {
        return false;
      }

      this.$refs[name].validate(valid => {
        this.is_submit = false;
        if (valid) {
          if (this.Title == '新建') {
            this.newForm.image = this.image;
            this.newForm.releaseTime = this.pbcFun.formatDate(
              new Date(this.newForm.releaseTime),
              'yyyy-MM-dd hh:mm:ss'
            );
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/innovation/notice/create`, this.newForm)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['searchValue']);

                  this.getData();
                  this.dialogFormVisible = false;
                  this.$message({
                    type: 'success',
                    message: '新增成功'
                  });
                }
              })
              .catch(error => {
                this.is_submit = true;
              });
          }
          if (this.Title == '编辑') {
            this.newForm.image = this.image;
            this.newForm.releaseTime = this.pbcFun.formatDate(
              new Date(this.newForm.releaseTime),
              'yyyy-MM-dd hh:mm:ss'
            );
            let obj = JSON.parse(JSON.stringify(this.newForm));
            // delete obj.id;
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/innovation/notice/update`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['searchValue']);

                  this.getData();
                  this.dialogFormVisible = false;
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  });
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
    },
    //发布
    release(row, value) {
      let obj = JSON.parse(JSON.stringify(row));
      obj.releaseFlag = value;
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/innovation/notice/update`, obj)
        .then(res => {
          if (res.code == 0) {
            this.getData();

            this.$message({
              type: 'success',
              message: value === 1 ? '发布成功' : '取消发布成功'
            });
          }
        });
    },
    //查找
    search() {
      this.currentPage = 1;
      this.getData();
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.http
              .request(
                `${urlConfig.devUrl}apij2/admin-api/innovation/notice/delete?ids=${[
                  this.deleteRow
                ]}`,
                '',
                'delete'
              )
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['searchValue']);
                  this.search();
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  });
                } else {
                  this.$message({
                    message: '失败！',
                    type: 'error'
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的新闻'
        });
      }
    },
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach(item => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData();
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, 'HouImg');
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64
            })
            .then(res => {
              this.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      // var img = new Image();
      // img.src = this.image;
      // img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.image = '';
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.news {
  width: 100%;
  height: 100%;
  .news-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    // margin-top: 20px;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  .news-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 178px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
</style>
